import { Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faCalendar, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from 'src/app/share/sharedsubject';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';

@Component({
    selector: 'app-order-out',
    templateUrl: './order-out.component.html',
    styleUrls: ['./order-out.component.scss'],
    standalone: false
})

export class OrderOutComponent implements OnInit {

  customSearchFn = () => true;
  private offcanvasRef: any = null;
  
  protected faCalendar = faCalendar;
  errorMessage: string;
  addProductForm!: FormGroup;
  isLoading = false;
  userDetails: any;
  showFullPaymentOption = true;
  showSplitPaymentOption = false;
  showReferenceName = false;
  showSwpCharges = false;
  tyreModelObj: any = { page: 0 };
  tyreSizeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreMakeObj: any = { page: 0, searchTerm: '', list: [] };
  hasTax: boolean = true;
  phoneList: any[] = [];
  selectedPhoneNumber: any;
  checkSplitCount: boolean = true;
  swpCharges: any = 0;
  filteredActiveBranches: any[] = [];
  leadOptions = [
    { value: 'WalkIn', label: 'Walk-in' },
    { value: 'TyreBuzzar', label: 'Tyre Buzzar' },
    { value: 'Google', label: 'Google' },
    { value: 'JustDial', label: 'Just Dial' },
    { value: 'Reference', label: 'Reference' }
  ];
  paymentTypes = [
    { value: 'Full', label: 'Full' },
    { value: 'Split', label: 'Split' }
  ];
  paymentModes = [
    { value: 'Cash', label: 'Cash' },
    { value: 'BankTransfer', label: 'Bank Transfer' },
    { value: 'UPI', label: 'UPI' },
    { value: 'Card', label: 'Card (Charges will be applied)' },
    { value: 'BajajFinance', label: 'Bajaj Finance' },
    { value: 'Credit', label: 'Credit' }
  ];
  metaDataList: any;
  selectedServices: { [key: string]: boolean } = {};
  tyreModelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];
  priceDetailsArray: { minPrice: number; maxPrice: number; avgPrice: number }[] = [];

  @ViewChild('accountFormModal') accountFormModal!: TemplateRef<any>;
  isEditMode: boolean = false;
  transactionId: string = '';
  preSelectedBranch: string = '';
  preSelectedMode: string = '';

  accountState: { [key: string]: { list: any[], page: number, loading: boolean, isLastPage: boolean } } = {
    Full: { list: [], page: 0, loading: false, isLastPage: false },
    Cash: { list: [], page: 0, loading: false, isLastPage: false },
    BankTransfer: { list: [], page: 0, loading: false, isLastPage: false },
    UPI: { list: [], page: 0, loading: false, isLastPage: false },
    Card: { list: [], page: 0, loading: false, isLastPage: false },
    BajajFinance: { list: [], page: 0, loading: false, isLastPage: false }
  };

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;


  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterModelService: MasterModelService,
    private readonly companyService: CompanyServiceService,
    private readonly stockService: StockService,
    private readonly masterMakeService: MasterMakeService,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly elRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly messageService: MessageService,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly paymentAccountsService: PaymentAccountsService,
    private readonly route: ActivatedRoute,
  ) {
    this.addProductForm = this.formBuilder.group({
      company: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      discount: [null],
      totalAmount: [null],
      serviceAmount: [''],
      swpCharges: [null],
      paymentType: ['Full', [Validators.required]],
      paymentMode: ['UPI', [Validators.required]],
      hasTax: [true],
      customerName: ['', [Validators.required]],
      emailAddress: ['', Validators.pattern(RegExpPatterns.EmailPattern)],
      phoneNumber: ['', [Validators.pattern(RegExpPatterns.MobilePattern), Validators.required]],
      address: this.formBuilder.group({
        locality: [''],
      }),
      totalPriceWithCharge: [null],
      cashAmount: [null],
      bankTransferAmount: [null],
      upiAmount: [null],
      cardAmount: [null],
      paymentAccount: [null],
      cashAccount: [null],
      bankTransferAccount: [null],
      upiAccount: [null],
      cardAccount: [null],
      bajajFinanceAmount: [null],
      bajajFinanceAccount: [null],
      lead: [null],
      reference: ['', [Validators.pattern(RegExpPatterns.MobilePattern)]],
      descriptionNote: ['', [Validators.maxLength(120)]],
      editReason: [''],
      stock: this.formBuilder.array([this.createItemGroup()]),
      averageRunPerDay: [''],
    });
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
 }

  createItemGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null],
      quantity: [null, [Validators.required, Validators.min(1), Validators.maxLength(10)]],
      tyresAmount: [null, [Validators.required, Validators.maxLength(10)]],
    });
  }

  get stock(): FormArray {
    return this.addProductForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    if(this.isEditMode) return
    this.stock.push(this.createItemGroup());
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
    this.tyreModelList.push({ search: '', list: [], page: 0});
  }

  removeItem(index: number): void {
    if(this.isEditMode) return
    let quantity = (this.addProductForm.get('stock') as FormArray).controls[index].get('quantity')?.value;
    let tyresAmount = (this.addProductForm.get('stock') as FormArray).controls[index].get('tyresAmount')?.value;
    let totalAmt = this.addProductForm.value.totalAmount - (quantity * tyresAmount);
    if (quantity && tyresAmount) {
      this.addProductForm.get('totalAmount')?.setValue(totalAmt);
    }
    this.stock.removeAt(index);
    this.priceDetailsArray.splice(index, 1);  
    this.tyreModelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
      this.addProductForm.get('company')?.setValidators([Validators.required]);
      this.addProductForm.get('company')?.setValue(null, { emitEvent: false });
    } else {
      this.addProductForm.get('company')?.setValue(this.userDetails?.company);
      this.onBranchChange();
    }
    this.initData();
    this.getMetaDataDetails();
    this.checkForEdit();
  }

  checkForEdit() {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.transactionId = params['id'];
        this.isEditMode = true;
        this.addProductForm.get('editReason')?.setValidators([Validators.required]);
        this.addProductForm.get('editReason')?.updateValueAndValidity();
        this.stockService.getTransactionDetails(params['id']).subscribe({
          next: (res: any) => {
            if (res.data) {
              this.patchTransactionData(res.data);
            }
          },
          error: (error: any) => {
            this.errorMessage = error?.error?.error?.message || 'Something went wrong';
          }
        })
      }
    });
  }

  initData() {
    this.tyreSizeObj.searchTerm = '';
    this.tyreSizeObj.page = 0;
    this.tyreMakeObj.searchTerm = '';
    this.tyreModelObj.name = '';
    this.getTyreSize();
    this.getTyreMake();
  }

  onBranchChange() {
    const val = this.addProductForm.get('company')?.value;
    this.resetAllAccounts();
    if (val) {
      if (this.addProductForm.get('paymentType')?.value === 'Full') {
        const pm = this.addProductForm.get('paymentMode')?.value;
        if (pm && pm !== 'Credit') this.fetchAccounts('Full');
      } else {
        this.fetchAccounts('Cash');
        this.fetchAccounts('BankTransfer');
        this.fetchAccounts('UPI');
        this.fetchAccounts('Card');
        this.fetchAccounts('BajajFinance');
      }
    }
  }

  resetAllAccounts() {
    Object.keys(this.accountState).forEach(key => this.resetAccounts(key));
  }

  resetAccounts(type: string) {
    this.accountState[type] = { list: [], page: 0, loading: false, isLastPage: false };
    switch(type) {
      case 'Full': this.addProductForm.get('paymentAccount')?.setValue(null); break;
      case 'Cash': this.addProductForm.get('cashAccount')?.setValue(null); break;
      case 'BankTransfer': this.addProductForm.get('bankTransferAccount')?.setValue(null); break;
      case 'UPI': this.addProductForm.get('upiAccount')?.setValue(null); break;
      case 'Card': this.addProductForm.get('cardAccount')?.setValue(null); break;
      case 'BajajFinance': this.addProductForm.get('bajajFinanceAccount')?.setValue(null); break;
    }
  }

  fetchAccounts(type: string, isScroll: boolean = false) {
    const company = this.addProductForm.get('company')?.value;
    if (!company) return;

    let actualType = type === 'Full' ? this.addProductForm.get('paymentMode')?.value : type;
    if (!actualType || actualType === 'Credit') return;

    const requestType = actualType;

    if (isScroll) {
      this.accountState[type].page++;
    } else {
      this.accountState[type].page = 0;
      this.accountState[type].isLastPage = false;
      this.accountState[type].list = [];
    }

    if (this.accountState[type].loading || this.accountState[type].isLastPage) return;

    this.accountState[type].loading = true;

    this.paymentAccountsService.getCompanyPaymentAccount({ 
      company: company, paymentType: actualType, 
      page: this.accountState[type].page,
      status: true, sort: '_id', sortDir: 1
    }).subscribe({
      next: (res: any) => {
        this.accountState[type].loading = false;
        const currentActualType = type === 'Full' ? this.addProductForm.get('paymentMode')?.value : type;
        if (currentActualType !== requestType) return;

        if (res.data && res.data.length > 0) {
          const existingIds = new Set(this.accountState[type].list.map((a: any) => a._id));
          const newItems = res.data.filter((a: any) => !existingIds.has(a._id));
          this.accountState[type].list = [...this.accountState[type].list, ...newItems];
          this.selectDefaultAccount(res.data, type);
        } else {
          this.accountState[type].isLastPage = true;
        }
      },
      error: () => {
        this.accountState[type].loading = false;
      }
    });
  }

  private selectDefaultAccount(resData: any[], type: string) {
    if (this.accountState[type].page !== 0 || this.isEditMode) return;
    const defaultAcc = resData.find((a: any) => a.default);
    if (!defaultAcc) return;

    if (type === 'Full') {
      this.addProductForm.get('paymentAccount')?.setValue(defaultAcc._id);
      return;
    }

    const prefix = this.getControlPrefix(type);
    if (prefix) {
      const amount = this.addProductForm.get(`${prefix}Amount`)?.value;
      if (amount > 0) {
        this.addProductForm.get(`${prefix}Account`)?.setValue(defaultAcc._id);
      }
    }
  }

  onAccountScroll(type: string) {
    this.fetchAccounts(type, true);
  }

  getControlPrefix(type: string): string {
    switch(type) {
      case 'Cash': return 'cash';
      case 'BankTransfer': return 'bankTransfer';
      case 'UPI': return 'upi';
      case 'Card': return 'card';
      case 'BajajFinance': return 'bajajFinance';
      default: return '';
    }
  }

  onPaymentModeChange(val: string) {
    if (this.addProductForm.get('paymentType')?.value === 'Full') {
      this.resetAccounts('Full');
      if (val && val !== 'Credit') {
        this.fetchAccounts('Full');
      }
    }
    this.calculateTotalService(); 
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.addProductForm.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) {
      apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    }
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      if (this.tyreSizeObj.page === 0) {
        this.tyreSizeObj.list = res.data || [];
      } else {
        this.tyreSizeObj.list = [...this.tyreSizeObj.list, ...(res.data || [])];
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      this.tyreMakeObj.list = res.data || [];
    });
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose(index: number) {
    if (this.tyreModelList[index].search) {
      this.tyreModelList[index].page = 0;
      this.tyreModelList[index].search = '';
      
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      
      let selectedGroup: any = this.stock?.controls[index];
      let makeValue = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = makeValue;
      
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  patchTransactionData(data: any) {
    this.addProductForm.patchValue({
      company: data.company,
      discount: data.discount,
      totalAmount: data.totalAmount,
      serviceAmount: data.serviceAmount,
      swpCharges: data.swpCharges,
      paymentType: data.paymentType,
      hasTax: data.hasTax,
      customerName: data.customerId?.customerName ,
      phoneNumber: data.customerId?.phoneNumber,
      emailAddress: data.customerId?.emailAddress,
      address: {
        locality: data.customerId?.address?.locality
      },
      lead: data.lead,
      reference: data.reference,
      descriptionNote: data.descriptionNote,
      averageRunPerDay: data.averageRunPerDay,
    });

    this.selectedPhoneNumber = data.customerId?.phoneNumber;

    this.addProductForm.get('company')?.disable();
    this.addProductForm.get('customerName')?.disable();
    this.addProductForm.get('phoneNumber')?.disable();
    this.addProductForm.get('emailAddress')?.disable();
    this.addProductForm.get('address.locality')?.disable();
    this.addProductForm.get('lead')?.disable();
    this.addProductForm.get('averageRunPerDay')?.disable();
    this.addProductForm.get('descriptionNote')?.disable();

    const stockFormArray = this.addProductForm.get('stock') as FormArray;
    stockFormArray.clear();
    this.priceDetailsArray = [];
    this.tyreModelList = [];

    data.stock.forEach((item: any, index: number) => {
      const group = this.createItemGroup();
      group.patchValue({
        tyreSize: item.tyreSize,
        tyreMake: item.tyreMake,
        tyreModel: item.tyreModel,
        quantity: item.quantity,
        tyresAmount: item.tyresAmount,
      });
      
      group.get('tyreSize')?.disable();
      group.get('tyreMake')?.disable();
      group.get('tyreModel')?.disable();

      stockFormArray.push(group);
      
      this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
      this.tyreModelList.push({ search: '', list: [], page: 0 });

      this.getFreightDetails(index);
    });

    const patchServices = () => {
      if (data.service && Array.isArray(data.service)) {
        data.service.forEach((s: any) => {
          const exists = this.metaDataList.find((m: any) => m._id === s.lookupId);
          if (!exists) {
            this.metaDataList.push({
              _id: s.lookupId,
              label: s.label,
              fieldType: 'Number'
            });
            this.addProductForm.addControl(s.lookupId, new FormControl(""));
          }
          this.addProductForm.get(s.lookupId)?.patchValue(s.value);
          if (s.value !== null && s.value !== undefined && s.value !== '') {
            this.selectedServices[s.lookupId] = true;
          }
        })
      }
    };

    if (this.metaDataList) {
      patchServices();
    } else {
      const sub = this.masterMakeService.getActiveMetaDataDetails().subscribe(() => {
        patchServices();
        sub.unsubscribe();
      });
    }

    this.showPayDetailsForm(data.paymentType);

    if (data.paymentAccounts && Array.isArray(data.paymentAccounts)) {
      data.paymentAccounts.forEach((pa: any) => {
        const accountId = pa.paymentId?._id || pa.paymentId;
        const accountName = pa.paymentId?.accountName || 'Unknown Account';
        const amount = pa.amount;
        const listType = data.paymentType === 'Full' ? 'Full' : pa.mode;

        if (this.accountState[listType]) {
          const exists = this.accountState[listType].list.find((a: any) => a._id === accountId);
          if (!exists) {
            this.accountState[listType].list.push({ _id: accountId, accountName: accountName });
          }
        }

        if (data.paymentType === 'Full') {
          this.addProductForm.get('paymentMode')?.patchValue(pa.mode);
          this.resetAccounts('Full');
          this.fetchAccounts('Full');
          this.addProductForm.get('paymentAccount')?.patchValue(accountId);
        } else {
          const prefix = this.getControlPrefix(pa.mode);
          if (prefix) {
            this.addProductForm.get(`${prefix}Amount`)?.patchValue(amount);
            this.addProductForm.get(`${prefix}Account`)?.patchValue(accountId);
          }
        }
      });
    }

    if (data.paymentType === 'Split') {
      this.resetAllAccounts();
      this.fetchAccounts('Cash');
      this.fetchAccounts('BankTransfer');
      this.fetchAccounts('UPI');
      this.fetchAccounts('Card');
      this.fetchAccounts('BajajFinance');
      setTimeout(() => this.splitAmountSum());
    }
  }

  selectMake(value: any, index: any) {
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.name = '';
    this.tyreModelObj.page = 0;
    this.tyreModelList[index].page = 0;
    this.tyreModelList[index].search = '';
    this.tyreModelList[index].list = [];
    if (value) {
      this.tyreModelObj.tyreMake = value
      this.getTyreModel(this.tyreModelObj, index);
    }
    this.getFreightDetails(index);
  }

  getTyreModel(selectedMake: any, index: number) {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      if (this.tyreModelObj.page == 0) {
        this.tyreModelList[index] = { ...this.tyreModelList[index], list: res.data || [] }
      }
      else {
        this.tyreModelList[index] = { ...this.tyreModelList[index], list: this.tyreModelList[index].list.concat(res.data || []) }
      }
    });
  }


  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = (res.data || []).filter((c: any) => c.status === 'Active') || [];
    });
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    let tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  saveProduct() {
    if (!this.validateSplitAmount() || this.isLoading) return;
    if(this.isEditMode) {
      this.saveEditedProduct()
    } else {
      this.saveNewProduct()
    }
  }


  validateSplitAmount(): boolean {
    const paymentType = this.addProductForm.get('paymentType')?.value;
    if (paymentType === 'Split') {
      const totalAmount = this.addProductForm.get('totalAmount')?.value || 0;
      const splitAmt =
        (this.addProductForm.get('upiAmount')?.value || 0) +
        (this.addProductForm.get('bankTransferAmount')?.value || 0) +
        (this.addProductForm.get('cashAmount')?.value || 0) +
        (this.addProductForm.get('cardAmount')?.value || 0) +
        (this.addProductForm.get('bajajFinanceAmount')?.value || 0);
      if (splitAmt !== totalAmount) {
        this.errorMessage = `Split amount total (₹${splitAmt}) does not match the order total (₹${totalAmount}). Please adjust the split amounts.`;
        return false;
      }
    }
    return true;
  }

  saveEditedProduct() {
    this.isLoading = true;
    let payload: any = {}
    payload = this.generatePayloadforEdit();
    this.stockService.saveStockOutEdit(this.transactionId, payload).subscribe({
      next:(res: any)=> {
        setTimeout(() => {
          this.messageService.sendMessage(res.message || "Transaction edited successfully");
        })
        this.router.navigate(['/order-list'])
      }, 
      error: (error)=> {
        this.errorMessage = error?.error?.error?.message || (Array.isArray(error?.error?.message) ? (error?.error?.message[0]) : (error?.error?.message || error?.message || error?.error))
        this.isLoading = false;
      }
    })
  }

  saveNewProduct() {
    this.isLoading = true;
    let  payload: any = {}
    payload = this.generatePayload();
    this.stockService.saveStockOutDetails(payload).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      })
      this.router.navigate(['/order-list'])
    },
      error: (error) => {
      this.isLoading = false;
      this.errorMessage = error?.error?.error?.message || (Array.isArray(error?.error?.message) ? (error?.error?.message[0]) : (error?.error?.message || error?.message || error?.error))
    }
    })
  }

  generatePayload() {
    let payload: any= {};
    if (!this.addProductForm.value) return {}
    let formValues = { ...this.addProductForm.value }
    payload = {
      company:formValues.company,
      service: this.getServiceData(),
      stock: formValues.stock,
      paymentAccounts: this.getPaymentAccountsPayload(),
      paymentType: formValues.paymentType,
      totalAmount: formValues.totalAmount,
      discount: formValues.discount,
      swpCharges: formValues.swpCharges,
      phoneNumber: formValues.phoneNumber,
      customerName: formValues.customerName,
      emailAddress: formValues.emailAddress,
      address: formValues.address,
      lead: formValues.lead,
      averageRunPerDay: formValues.averageRunPerDay,
      descriptionNote: formValues.descriptionNote,
      reference: formValues.reference,
      serviceAmount: formValues.serviceAmount,
    }
    payload.hasTax = true; //imported to backend
    if (formValues.paymentType === 'Full' && formValues.paymentMode === 'Credit') {
      payload.paymentMode = 'Credit'
    }
    return payload
  }


  generatePayloadforEdit() {
    let payload: any = {};
    if (!this.addProductForm.value) return {}
    let formValues = { ...this.addProductForm.getRawValue() }
    payload = {
      company: formValues.company,
      service: this.getServiceData(),
      stock: formValues.stock,
      paymentAccounts: this.getPaymentAccountsPayload(),
      paymentType: formValues.paymentType,
      totalAmount: formValues.totalAmount,
      discount: formValues.discount,
      swpCharges: formValues.swpCharges,
      serviceAmount: formValues.serviceAmount,
      reason: formValues.editReason
    }
    payload.hasTax = true;
    if (formValues.paymentType === 'Full' && formValues.paymentMode === 'Credit') {
      payload.paymentMode = 'Credit'
    }
    return payload
  }


  showPayDetailsForm(paymentType: any) {
    if (paymentType == "Full") {
      this.showFullPaymentOption = true;
      this.showSplitPaymentOption = false;
      this.addProductForm.get('upiAmount')?.setValue(null);
      this.addProductForm.get('cardAmount')?.setValue(null);
      this.addProductForm.get('bankTransferAmount')?.setValue(null);
      this.addProductForm.get('cashAmount')?.setValue(null);
      this.addProductForm.get('bajajFinanceAmount')?.setValue(null);
      if (!this.isEditMode) {
        this.addProductForm.get('paymentMode')?.setValue('UPI');
      }
      this.checkSplitCount = true;
      this.addProductForm.get('paymentMode')?.setValidators(Validators.required);
      this.addProductForm.get('paymentMode')?.updateValueAndValidity();
      if (!this.isEditMode) {
        this.resetAccounts('Full');
        this.fetchAccounts('Full');
      }
    } else {
      this.showFullPaymentOption = false;
      this.showSplitPaymentOption = true;
      this.checkSplitCount = false;
      this.addProductForm.get('paymentMode')?.clearValidators();
      this.addProductForm.get('paymentMode')?.updateValueAndValidity();
      this.addProductForm.get('swpCharges')?.setValue(null);
      if (!this.isEditMode) {
        this.resetAllAccounts();
        this.fetchAccounts('Cash');
        this.fetchAccounts('BankTransfer');
        this.fetchAccounts('UPI');
        this.fetchAccounts('Card');
        this.fetchAccounts('BajajFinance');
      }
    }
    this.showSwpCharges = false;
    this.addProductForm.get('swpCharges')?.setValue(null);
    this.calculateTotalService();
  }

  onScrollTyreSize() {
    if (this.tyreSizeObj.list.length % 20 === 0) {
      this.tyreSizeObj.page++;
      this.getTyreSize();
    }
  }

  calculateTotalService() {
    this.showSwpCharges = false;
      let serviceTotalCal = 0;
      (this.metaDataList || []).forEach((metaDataItem: any) => {
      if (this.selectedServices[metaDataItem._id]) {
        let formValue = Number(this.addProductForm.get(metaDataItem._id)?.value || 0);
        if (formValue) {
          serviceTotalCal += formValue;
        }
      }
    });
    if (!this.hasTax) {
      serviceTotalCal = Math.ceil(serviceTotalCal * 1.18);
    }
    this.addProductForm.get('serviceAmount')?.setValue(serviceTotalCal);
      let tyreAmount = 0;
    (this.addProductForm.get('stock') as FormArray).controls.forEach((x: any) => {
      tyreAmount += (x.get('quantity')?.value || 0) * ((x.get('tyresAmount').value || 0));
    });
    if (!this.hasTax) {
      tyreAmount = Math.ceil(((this.addProductForm.get('totalAmount')?.value || 0) * ((this.addProductForm.get('quantity')?.value || 0))) * 1.28);
    }
    let totalAmt = serviceTotalCal + tyreAmount;
    let discount = Math.ceil((this.addProductForm.get('discount')?.value || 0));
    const discountControl = this.addProductForm.get('discount');

    if (discount > 0 && discount >= totalAmt) {
      discountControl?.setErrors({ discountExceeded: true });
    } else {
      if (discountControl?.hasError('discountExceeded')) {
        discountControl.setErrors(null);
      }
      totalAmt = totalAmt - discount;
    }
    const payMode = this.addProductForm.get('paymentMode')?.value;
    const payType = this.addProductForm.get('paymentType')?.value;
    const cardAmt = Number(this.addProductForm.get('cardAmount')?.value || 0);

    this.swpCharges = this.getCalculatedSwpCharges(totalAmt, payType, payMode, cardAmt);
    totalAmt = totalAmt + this.swpCharges;
    this.addProductForm.get('totalAmount')?.setValue(totalAmt);
  }

  private getCalculatedSwpCharges(totalAmt: number, payType: string, payMode: string, cardAmt: number): number {
    if (payType === "Full" && payMode === "Card") {
      this.showSwpCharges = true;
      let swpChargePer = Number(this.addProductForm.get('swpCharges')?.value || 0);
      if (swpChargePer < 0 || swpChargePer > 100 || Number.isNaN(swpChargePer)) {
        this.addProductForm.get('swpCharges')?.setValue(null);
        swpChargePer = 0;
      }
      return Math.ceil(((swpChargePer / 100) * totalAmt));
    } else if (payType === "Split" && cardAmt > 0) {
      this.showSwpCharges = false;
      let swpChargePer = Number(this.addProductForm.get('swpCharges')?.value || 0);
      if (swpChargePer < 0 || swpChargePer > 100 || Number.isNaN(swpChargePer)) {
        this.addProductForm.get('swpCharges')?.setValue(null);
        swpChargePer = 0;
      }
      return Math.ceil(((swpChargePer / 100) * cardAmt));
    } else {
      this.addProductForm.get('swpCharges')?.setValue(null);
      return 0;
    }
  }
  

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    let value = event?.term ? event.term : '';
    this.tyreSizeObj.searchTerm = value;
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }

  checkLeadType(leadType: any) {
    if (leadType == "Reference") {
      this.showReferenceName = true;
    } else {
      this.showReferenceName = false;
      this.addProductForm.get('leadRefrenceName')?.setValue('');
    }
  }

  onTyreModelInputChange(event: any, index: number) {
    this.tyreModelObj.page = 0;
    this.tyreModelList[index].page = 0;
    let value = event?.term ? event.term : '';
    this.tyreModelObj.name = value;
    this.tyreModelList[index].search = value;
    let selectedModel: any = this.stock?.controls[index];
    let makeValue = selectedModel?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = makeValue;
    this.getTyreModel(this.tyreModelObj, index);
  }

  scroll(index: number) {
    if (this.tyreModelList[index].list.length % 20 === 0) {
      this.tyreModelObj.name = this.tyreModelList[index].search;
      this.tyreModelList[index].page++;
      this.tyreModelObj.page = this.tyreModelList[index].page;
      let selectedGroup: any = this.stock?.controls[index];
      let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = selectedTyreMake;
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  splitAmountSum() {
    const sumAmount = this.elRef.nativeElement.querySelector('#sumAmount');
    const payType = this.addProductForm.get('paymentType')?.value;
    const upiAmount = this.addProductForm.get('upiAmount')?.value;
    const bankTransferAmount = this.addProductForm.get('bankTransferAmount')?.value;
    const cashAmount = this.addProductForm.get('cashAmount')?.value;
    const cardAmount = this.addProductForm.get('cardAmount')?.value;
    const bajajFinanceAmount = this.addProductForm.get('bajajFinanceAmount')?.value;
    let count = 0;
    if (upiAmount) {
      count++;
    }
    if (bankTransferAmount) {
      count++;
    }
    if (cashAmount) {
      count++;
    }
    if (cardAmount) {
      count++;
    }
    if (bajajFinanceAmount) {
      count++;
    }
    if (payType == "Split" && count >= 2) {
      this.checkSplitCount = true;

    } else {
      this.checkSplitCount = false;
    }

    const splitAmt = (this.addProductForm.get('upiAmount')?.value || 0) +
      (this.addProductForm.get('bankTransferAmount')?.value || 0) +
      (this.addProductForm.get('cashAmount')?.value || 0) +
      (this.addProductForm.get('cardAmount')?.value || 0) +
      (this.addProductForm.get('bajajFinanceAmount')?.value || 0);
    if (sumAmount) {
      this.renderer.setProperty(sumAmount, 'innerHTML', splitAmt);
    }
  }


  onOptionPhoneSelected(phoneNumber: any) {
    let existingCustomer: any = (this.phoneList || []).filter(cust => cust.phoneNumber === phoneNumber.toString());
    if (existingCustomer?.[0]) {
      this.addProductForm.controls['customerName'].setValue((existingCustomer || [])[0]?.customerName);
      this.addProductForm.controls['emailAddress'].setValue((existingCustomer || [])[0]?.emailAddress);
      this.addProductForm.controls['lead'].setValue((existingCustomer || [])[0]?.lead);
      this.addProductForm.get('address.locality')?.patchValue((existingCustomer || [0])[0]?.address.locality);
    }
  }

  getUserIdsFirstWay($event: any) {
    this.stockService.getPhoneDetails({ phoneNumber: $event.target.value }).subscribe((res: any) => {
      this.phoneList = res.data || [];
    })
  }

  onInputNumber(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.addProductForm.controls['reference'].setValue(inputElement.value);
    }
  }

  getFreightDetails(index: any) {
    const formValues = this.addProductForm.getRawValue();
    const tyreSize = formValues.stock[index].tyreSize;
    const tyreMake = formValues.stock[index].tyreMake;
    const tyreModel = formValues.stock[index].tyreModel;
    let payload : any = {
      tyreSize,
      tyreMake,
      tyreModel
      }
    if (!tyreSize || !tyreMake) {
      return;
    }
    this.stockService.freightDetails(payload).subscribe(
      (res: any) => {
        setTimeout(() => {
          this.priceDetailsArray[index] = {
            minPrice: res?.data?.minPrice || 0,
            maxPrice: res?.data?.maxPrice || 0,
            avgPrice: res?.data?.avgPrice || 0,
          };
        });
      },
    );
  }

  getMetaDataDetails() {
    this.masterMakeService.getActiveMetaDataDetails().subscribe({
      next: (res: any) => {
        this.metaDataList = res.data;
        this.generateMetaForm(this.metaDataList);
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  generateMetaForm(metaData: any = []): void {
    metaData.forEach((data: any) => {
      this.selectedServices[data._id] = false;
      this.addProductForm.addControl(data._id, new FormControl(null));
    });
  }

  toggleService(field: any, event?: any) {
    if (this.isEditMode) return;
    if (event) {
      event.stopPropagation();
    }
    const currentState = !!this.selectedServices[field._id];
    const newState = !currentState;
    this.selectedServices[field._id] = newState;
    const control = this.addProductForm.get(field._id);

    if (newState) {
      control?.setValidators([Validators.required, Validators.min(1)]);
      const defaultAmt = Number(field.amount || field.minAmount || 0);
      if (defaultAmt > 0) {
        control?.setValue(defaultAmt);
      } else {
        control?.setValue(null);
      }
    } else {
      control?.setValue(null);
      control?.clearValidators();
    }
    control?.markAsTouched();
    control?.updateValueAndValidity();
    this.calculateTotalService();
  }

  onAmountInput(field: any) {
    if (this.isEditMode) return;
    const control = this.addProductForm.get(field._id);
    const val = control?.value;

    if (!this.selectedServices[field._id] && val !== null && val !== undefined && val !== '') {
      this.selectedServices[field._id] = true;
      control?.setValidators([Validators.required, Validators.min(1)]);
      control?.updateValueAndValidity();
    }
    this.calculateTotalService();
  }

  getServiceData() {
    let services: any = [];
    let formValues = this.addProductForm.getRawValue();
    this.metaDataList.forEach((metaDataItem: any) => {
      let formValue = formValues[metaDataItem._id];
      if (formValue !== null && formValue !== undefined && formValue !== '') {
        services.push({
          lookupId: metaDataItem._id,
          label: metaDataItem.label,
          value: formValue
        });
      }
    });
    return services;
  }

  onSplitAmountChange() {
    this.splitAmountSum();
    const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
    splitTypes.forEach(type => {
      const prefix = this.getControlPrefix(type);
      const amountControl = this.addProductForm.get(`${prefix}Amount`);
      const accountControl = this.addProductForm.get(`${prefix}Account`);
      
      if (amountControl && accountControl) {
        if (amountControl.value > 0) {
          if (!accountControl.value) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) {
              accountControl.setValue(defaultAcc._id);
            }
          }
        } else {
          accountControl.setValue(null);
        }
      }
    });

    const cardAmt = this.addProductForm.get('cardAmount')?.value;
    if (!cardAmt || Number(cardAmt) <= 0) {
      this.addProductForm.get('swpCharges')?.setValue(null);
    }
    this.calculateTotalService();
  }

  getPaymentAccountsPayload(): any[] {
    const paymentType = this.addProductForm.get('paymentType')?.value;
    let accounts: any[] = [];
    
    if (paymentType === 'Full') {
      const paymentMode = this.addProductForm.get('paymentMode')?.value;
      if (paymentMode && paymentMode !== 'Credit') {
        let acc = this.addProductForm.get('paymentAccount')?.value;
        if (!acc) {
          const defaultAcc = this.accountState['Full'].list.find((a: any) => a.default);
          if (defaultAcc) acc = defaultAcc._id;
        }
        if (acc) accounts.push({ paymentId: acc, amount: this.addProductForm.get('totalAmount')?.value, mode: paymentMode });
      }
    } else if (paymentType === 'Split') {
      const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
      splitTypes.forEach(type => {
        const prefix = this.getControlPrefix(type);
        const amountControl = this.addProductForm.get(`${prefix}Amount`);
        if (amountControl && amountControl.value > 0) {
          let acc = this.addProductForm.get(`${prefix}Account`)?.value;
          if (!acc) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) acc = defaultAcc._id;
          }
          if (acc) accounts.push({ paymentId: acc, amount: amountControl.value, mode: type });
        }
      });
    }
    return accounts;
  }

  addNewPaymentAccount(paymentMode?: string) {
    this.preSelectedBranch = this.addProductForm.get('company')?.value || '';
    this.preSelectedMode = paymentMode || '';
    this.offcanvasRef = this.offcanvasService.open(this.accountFormModal, {
      position: 'end',
      panelClass: 'payment-account-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });
  }

  onAccountSave(data: any) {
    this.offcanvasRef?.close();
    const savedMode = data.paymentType ;
    if (this.addProductForm.get('paymentType')?.value === 'Full') {
       this.resetAccounts('Full');
       this.fetchAccounts('Full');
    } else {
      this.resetAccounts(savedMode);
      this.fetchAccounts(savedMode);
    }
  }


}
